/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-06-14T15:25:43.892
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';

import {
	saveRentLeaseContractReceiptAgreement,
	getRentLeaseContractReceiptAgreementCreateInit,
	getRentLeaseContractReceiptAgreementEditInit,
	getRentLeaseContractReceiptAgreementView,
	deleteRentLeaseContractReceiptAgreement
} from '@api/rentmanage/RentLeaseContractReceiptAgreement';

import {
	cloneObj
} from '@/plugins/utils';

import RespCommonDef from '@/plugins/utils/RespCommonDef';

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary),
		CompoundEntityDictionaryAdd: cloneObj(RespCommonDef.CompoundEntityDictionary),
	},

	actions: {
		getRentLeaseContractReceiptAgreementCreateInit({
			state
		}) {
			return new Promise((resolve, reject) => {
				getRentLeaseContractReceiptAgreementCreateInit({})
					.then(async res => {
						state.CompoundEntityDictionaryAdd = res;
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentLeaseContractReceiptAgreementEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentLeaseContractReceiptAgreementEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},


		saveRentLeaseContractReceiptAgreement({}, RentLeaseContractReceiptAgreement) {
			return new Promise((resolve, reject) => {
				saveRentLeaseContractReceiptAgreement(RentLeaseContractReceiptAgreement)
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentLeaseContractReceiptAgreementView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentLeaseContractReceiptAgreementView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		deleteRentLeaseContractReceiptAgreement({
			state
		}, {id}) {
			return new Promise((resolve, reject) => {
				deleteRentLeaseContractReceiptAgreement({
						id
					})
					.then(async res => {
						resolve(res);
					})
					.catch(err => {
						reject(err);
					})
			})
		}
	}
};
